import { formatCurrency } from 'common/FormatUtilities';
import { Maybe } from 'graphql/jsutils/Maybe';
import React from 'react';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { Plus } from 'src/shared/design-system/Icon';
import { BodySmall } from 'src/shared/design-system/Text';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import { titleCase } from 'src/shared/utils/DateTimeUtilities';
import styled, { css } from 'styled-components';
import {
  BorderRadius,
  Colors,
  FontFamily,
  FontSize,
  FontWeight,
  LineHeight,
  Spacing,
} from 'web-common/src/shared/styles';

const SideCardWrapper = styled.div<{ smallScreen?: boolean }>`
  max-width: 130px;
  margin-left: 10px;
  margin-right: 10px;

  &:first-child {
    margin-left: 14px;
  }

  &:last-child {
    margin-right: 14px;
  }

  ${ifProp(
    'smallScreen',
    css`
      width: 100%;
    `
  )}
`;

const SideCardImageWrapper = styled.div`
  max-width: 165px;
  max-height: 120px;
  overflow: hidden;

  margin: 0;
  margin-bottom: 5px;

  display: flex;
  justify-content: center;

  position: relative;
`;

const SideCardImage = styled(DynamicImage)`
  height: 78px;
  width: 130px;
  border-radius: ${BorderRadius.S};
`;

const DetailText = styled.span`
  color: ${Colors.GRAY_DARK_10};
  margin: 0;

  font-family: ${FontFamily.SANS};
  font-style: normal;
  font-weight: normal;

  font-size: ${FontSize.XS};
  line-height: ${LineHeight.S};
  margin-bottom: 10px;
`;

const Price = styled(DetailText)`
  color: ${Colors.BLACK};
  margin-right: ${Spacing.HALF};
  font-weight: ${FontWeight.SEMI_BOLD};
`;

const AddButton = styled.button`
  border: none;
  background-color: white;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: unset; // Fight bootstrap
  width: 24px;
  height: 24px;
  border-radius: 24px;

  position: absolute;
  top: 4px;
  right: 4px;
`;

type SideCardProps = {
  imageUrl?: Maybe<string>;
  description?: Maybe<string>;
  name: Maybe<string>;
  price: number;
  type?: Maybe<string>;
  incrementQuantity: () => void;
  smallScreen: boolean;
};

export const SideCard: React.FC<SideCardProps> = ({
  imageUrl,
  description,
  name,
  price,
  type,
  incrementQuantity,
  smallScreen,
}) => (
  <SideCardWrapper smallScreen={smallScreen}>
    <SideCardImageWrapper>
      <SideCardImage src={imageUrl ?? ''} sourceHeight={120} alt={description ?? ''} />
      <AddButton onClick={incrementQuantity}>
        <Plus width={20} height={20} symbolFill={Colors.GRAY_DARK_30} />
      </AddButton>
    </SideCardImageWrapper>
    <BodySmall>{name}</BodySmall>
    <DetailText>
      <Price>{formatCurrency(price)}</Price>
      {titleCase(type ?? '')}
    </DetailText>
  </SideCardWrapper>
);
